var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 1.5,
    fill: "#F3F6F9",
    stroke: "#E1EAF3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10842_1909",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10842_1909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 15.25H5.69613L13.3735 7.57262L12.4274 6.6265L4.75 14.3039V15.25ZM4.303 16.375C4.11088 16.375 3.94987 16.31 3.82 16.18C3.69 16.0501 3.625 15.8891 3.625 15.697V14.3976C3.625 14.2147 3.66012 14.0404 3.73037 13.8747C3.8005 13.7089 3.89713 13.5645 4.02025 13.4414L13.5179 3.94806C13.6313 3.84506 13.7564 3.7655 13.8934 3.70938C14.0306 3.65313 14.1743 3.625 14.3247 3.625C14.4751 3.625 14.6207 3.65169 14.7616 3.70506C14.9026 3.75844 15.0274 3.84331 15.136 3.95969L16.0519 4.88706C16.1683 4.99569 16.2512 5.12069 16.3007 5.26206C16.3502 5.40344 16.375 5.54481 16.375 5.68619C16.375 5.83706 16.3493 5.981 16.2978 6.118C16.2463 6.25513 16.1643 6.38038 16.0519 6.49375L6.55862 15.9797C6.4355 16.1029 6.29106 16.1995 6.12531 16.2696C5.95956 16.3399 5.78525 16.375 5.60238 16.375H4.303ZM12.8922 7.10781L12.4274 6.6265L13.3735 7.57262L12.8922 7.10781Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.95d059d2386e5c58fd3abda703656c95.svg";
export { ForwardRef as ReactComponent };